import React from 'react';
import useToolStore from '../../../store/useToolStore';
import { downloadFile } from '../../../utils/fileDownload';

const StoryboardFileList = () => {
  const generatedFiles = useToolStore((state) => state.generatedFiles);
  const selectedFileIndex = useToolStore((state) => state.selectedFileIndex);
  const setSelectedFileIndex = useToolStore((state) => state.setSelectedFileIndex);
  const previewInCodeWindow = useToolStore((state) => state.previewInCodeWindow);
  const previewFileIndex = useToolStore((state) => state.previewFileIndex);
  const setPreviewInCodeWindow = useToolStore((state) => state.setPreviewInCodeWindow);
  const setPreviewFileIndex = useToolStore((state) => state.setPreviewFileIndex);

  if (!generatedFiles || generatedFiles.length === 0) {
    return (
      <div className="h-full flex items-center justify-center bg-white dark:bg-gray-900">
        <div className="text-gray-600 dark:text-gray-500 text-sm">
          No files generated yet. Upload or paste a storyboard file to get started.
        </div>
      </div>
    );
  }

  const handlePreview = (index) => {
    // Set selected file for main preview panel
    setSelectedFileIndex(index);
    
    // Enable dual preview - show in both preview panel and code window
    setPreviewFileIndex(index);
    setPreviewInCodeWindow(true);
  };

  const handleDownload = (file) => {
    downloadFile(file.name, file.content);
  };

  return (
    <div className="h-full flex flex-col bg-white dark:bg-gray-900">
      <div className="bg-gray-100 dark:bg-gray-800 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
        <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300">Generated Files ({generatedFiles.length})</h3>
      </div>
      <div className="flex-1 overflow-y-auto">
        <div className="p-2 space-y-2">
          {generatedFiles.map((file, index) => (
            <div
              key={file.sceneId || index}
              className={`
                bg-gray-50 dark:bg-gray-800 rounded-lg p-3 border transition-colors
                ${selectedFileIndex === index ? 'border-primary-500 bg-gray-200 dark:bg-gray-700' : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600'}
              `}
            >
              <div className="flex items-center justify-between">
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-gray-900 dark:text-white truncate" title={file.name}>
                    {file.name}
                  </div>
                  <div className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                    Scene: {file.sceneId || 'N/A'}
                  </div>
                </div>
                <div className="flex items-center gap-2 ml-3">
                  {/* Preview Button */}
                  <button
                    onClick={() => handlePreview(index)}
                    className={`
                      p-2 rounded transition-colors relative
                      ${selectedFileIndex === index || previewFileIndex === index
                        ? 'bg-gradient-primary text-white' 
                        : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
                      }
                    `}
                    title="Preview file in both panels"
                  >
                    {previewFileIndex === index && previewInCodeWindow && (
                      <span className="absolute -top-1 -right-1 w-2 h-2 bg-green-400 rounded-full border border-gray-900"></span>
                    )}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      />
                    </svg>
                  </button>
                  
                  {/* Download Button */}
                  <button
                    onClick={() => handleDownload(file)}
                    className="p-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
                    title="Download file"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StoryboardFileList;
